// extracted by mini-css-extract-plugin
export default {"title":"index_title_1qIew","hotList":"index_hotList_LpTmd","emptyComment":"index_emptyComment_N-vLx"};